// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.championship-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding: 8px;
  gap: 1px;
}

.championship-list .search-input::placeholder {
  color: #64748b;
}

.championship-list .search-input:focus {
  outline: none;
  border-color: var(--button-bg);
}

.championship-list .sort-dropdown {
  position: relative;
}

.championship-list .sort-button {
  padding: 8px;
  background: #1e293b;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #f1f5f9;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.championship-list .sort-button:hover {
  background: #334155;
  border-color: var(--button-bg);
}

.championship-list .sort-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 100;
  min-width: 180px;
  overflow: hidden;
}

.championship-list .sort-option {
  display: block;
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  color: #f1f5f9;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.championship-list .sort-option:hover {
  background: #334155;
}

.championship-list .sort-option.active {
  background: var(--button-bg);
  color: white;
}

.championship-list .no-championships {
  padding: 32px 16px;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
}

.championship-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid #334155;
  border-radius: 6px;
  background: #0f172a;
  cursor: pointer;
  transition: background 0.2s;
  gap: 8px;
}

.championship-item:hover {
  background: #334155;
}

.championship-item.active {
  background: #0f172a;
  border-left: 3px solid var(--button-bg);
}

.championship-info {
  flex: 1 1;
  min-width: 0;
}

.championship-info h3 {
  margin: 0 0 6px 0;
  font-size: 16px;
  font-weight: 600;
  color: #f1f5f9;
  display: flex;
  align-items: center;
  gap: 8px;
}

.championship-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.championship-abbr {
  padding: 2px 8px;
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
}

.championship-season {
  font-size: 13px;
  color: #94a3b8;
}

.championship-stats {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 4px;
}

.championship-stats .separator {
  color: #475569;
}

.championship-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 4px;
}

.championship-badge.registrations {
  background: rgba(34, 197, 94, 0.2);
  color: #22c55e;
  border: 1px solid rgba(34, 197, 94, 0.4);
}

.championship-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.championship-actions .action-button {
  padding: 8px;
  background: #1e293b;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #f1f5f9;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.championship-actions .action-button:hover {
  transform: scale(1.05);
}

.championship-actions .action-button.edit:hover {
  background: var(--button-bg);
  border-color: var(--button-bg);
  color: white;
}

.championship-actions .action-button.delete:hover {
  background: #dc2626;
  border-color: #dc2626;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChampionshipList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd","sourcesContent":[".championship-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  padding: 8px;\r\n  gap: 1px;\r\n}\r\n\r\n.championship-list .search-input::placeholder {\r\n  color: #64748b;\r\n}\r\n\r\n.championship-list .search-input:focus {\r\n  outline: none;\r\n  border-color: var(--button-bg);\r\n}\r\n\r\n.championship-list .sort-dropdown {\r\n  position: relative;\r\n}\r\n\r\n.championship-list .sort-button {\r\n  padding: 8px;\r\n  background: #1e293b;\r\n  border: 1px solid #475569;\r\n  border-radius: 6px;\r\n  color: #f1f5f9;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.championship-list .sort-button:hover {\r\n  background: #334155;\r\n  border-color: var(--button-bg);\r\n}\r\n\r\n.championship-list .sort-menu {\r\n  position: absolute;\r\n  top: calc(100% + 4px);\r\n  right: 0;\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n  z-index: 100;\r\n  min-width: 180px;\r\n  overflow: hidden;\r\n}\r\n\r\n.championship-list .sort-option {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 10px 16px;\r\n  background: none;\r\n  border: none;\r\n  color: #f1f5f9;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.championship-list .sort-option:hover {\r\n  background: #334155;\r\n}\r\n\r\n.championship-list .sort-option.active {\r\n  background: var(--button-bg);\r\n  color: white;\r\n}\r\n\r\n.championship-list .no-championships {\r\n  padding: 32px 16px;\r\n  text-align: center;\r\n  color: #94a3b8;\r\n  font-size: 14px;\r\n}\r\n\r\n.championship-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 12px;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  background: #0f172a;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  gap: 8px;\r\n}\r\n\r\n.championship-item:hover {\r\n  background: #334155;\r\n}\r\n\r\n.championship-item.active {\r\n  background: #0f172a;\r\n  border-left: 3px solid var(--button-bg);\r\n}\r\n\r\n.championship-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.championship-info h3 {\r\n  margin: 0 0 6px 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.championship-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.championship-abbr {\r\n  padding: 2px 8px;\r\n  background: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #94a3b8;\r\n}\r\n\r\n.championship-season {\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.championship-stats {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  color: #94a3b8;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.championship-stats .separator {\r\n  color: #475569;\r\n}\r\n\r\n.championship-badge {\r\n  display: inline-block;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  margin-top: 4px;\r\n}\r\n\r\n.championship-badge.registrations {\r\n  background: rgba(34, 197, 94, 0.2);\r\n  color: #22c55e;\r\n  border: 1px solid rgba(34, 197, 94, 0.4);\r\n}\r\n\r\n.championship-actions {\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.championship-actions .action-button {\r\n  padding: 8px;\r\n  background: #1e293b;\r\n  border: 1px solid #475569;\r\n  border-radius: 6px;\r\n  color: #f1f5f9;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.championship-actions .action-button:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.championship-actions .action-button.edit:hover {\r\n  background: var(--button-bg);\r\n  border-color: var(--button-bg);\r\n  color: white;\r\n}\r\n\r\n.championship-actions .action-button.delete:hover {\r\n  background: #dc2626;\r\n  border-color: #dc2626;\r\n  color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
